export const CHATGPT_TOOL_PATH = "/tools/chatgpt-transcription";
export const CHATGPT_GUIDE_PATH = "/transcribe-video-with-chatgpt";
export const CHATGPT_CONNECTION_PATH = "/connections/chatgpt";

// Approval is separate from backend availability. Never use the private portal URL.
export function parseChatGptListingUrl(value: string | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.origin !== "https://chatgpt.com" || !/^\/plugins\/plugin_[a-zA-Z0-9_-]+\/?$/.test(url.pathname)) return null;
    if (url.username || url.password || url.search || url.hash) return null;
    return url.toString();
  } catch {
    return null;
  }
}

export const CHATGPT_PLUGIN_URL = parseChatGptListingUrl(process.env.NEXT_PUBLIC_CHATGPT_PLUGIN_URL);
export const CHATGPT_PLUGIN_LIVE = Boolean(CHATGPT_PLUGIN_URL);
